import React from 'react';
import {Col, Label, Row} from 'reactstrap';
import {AvForm, AvGroup, AvInput, AvRadio, AvRadioGroup} from 'availity-reactstrap-validation';
import {StepComponentProps} from '../followup-modal';
import {IPatientBaby} from 'app/shared/model/patient-baby.model';
import FollowupButtons from '../followup-buttons';
import '../followup.scss';

interface BabyAliveStepProps extends StepComponentProps {
  updateCurrentBaby?: (updates: Partial<IPatientBaby>) => void;
  currentBabyIndex?: number;
}

const BabyAliveStep: React.FC<BabyAliveStepProps> = ({
                                                       formData,
                                                       updateFormData,
                                                       onNext,
                                                       onPrevious,
                                                       canGoBack,
                                                       canGoNext,
                                                       patientCaseType,
                                                       journey,
                                                       updateCurrentBaby,
                                                       currentBabyIndex = 0,
                                                     }) => {
  const currentBaby = formData.patientBabies?.[currentBabyIndex];

  const handleSubmit = (event: any, values: any) => {
    onNext();
  };

  const handleBabyAliveChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value === 'true';
    if (updateCurrentBaby) {
      updateCurrentBaby({isAlive: value});
    }
  };

  const handlePretermChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value === 'true';
    if (updateCurrentBaby) {
      updateCurrentBaby({isPreterm: value});
    }
  };

  const handleLBWChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value === 'true';
    if (updateCurrentBaby) {
      updateCurrentBaby({isLbw: value});
    }
  };

  const handleSexChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (updateCurrentBaby) {
      updateCurrentBaby({sex: e.target.value});
    }
  };

  return (
    <div className="followup-step-container">
      <div className="followup-step-content">
        <h6 className="text-danger mb-4">Baby{currentBabyIndex > 0 ? `#${currentBabyIndex + 1}` : ''} Status</h6>
        <AvForm onValidSubmit={handleSubmit}>
          <div className="mb-4">
            <h6 className="mb-3">Is Baby{currentBabyIndex > 0 ? ` #${currentBabyIndex + 1}` : ''} Alive?</h6>
            <AvRadioGroup
              name="babyAlive"
              required
              value={currentBaby?.isAlive === true ? 'true' : currentBaby?.isAlive === false ? 'false' : null}
            >
              <Row>
                <Col md="6">
                  <Label className="radio-button-label" style={{ minHeight: '40px', height: '40px' }}>
                    <AvRadio
                      name="babyAlive"
                      value="true"
                      onChange={handleBabyAliveChange}
                      className="radio-button-input"
                    />
                    Yes
                  </Label>
                </Col>
                <Col md="6">
                  <Label className="radio-button-label" style={{ minHeight: '40px', height: '40px' }}>
                    <AvRadio
                      name="babyAlive"
                      value="false"
                      onChange={handleBabyAliveChange}
                      className="radio-button-input"
                    />
                    No
                  </Label>
                </Col>
              </Row>
            </AvRadioGroup>
          </div>

          <div className="mb-4">
            <h6 className="mb-3">Was the delivery completed before 37 weeks?</h6>
            <AvRadioGroup
              name="isPreterm"
              required
              value={currentBaby?.isPreterm === true ? 'true' : currentBaby?.isPreterm === false ? 'false' : null}
            >
              <Row>
                <Col md="6">
                  <Label className="radio-button-label" style={{ minHeight: '40px', height: '40px' }}>
                    <AvRadio
                      name="isPreterm"
                      value="true"
                      onChange={handlePretermChange}
                      className="radio-button-input"
                    />
                    Yes
                  </Label>
                </Col>
                <Col md="6">
                  <Label className="radio-button-label" style={{ minHeight: '40px', height: '40px' }}>
                    <AvRadio
                      name="isPreterm"
                      value="false"
                      onChange={handlePretermChange}
                      className="radio-button-input"
                    />
                    No
                  </Label>
                </Col>
              </Row>
            </AvRadioGroup>
          </div>

          <div className="mb-4">
            <h6 className="mb-3">Is Baby LBW (Low Birth Weight)?</h6>
            <AvRadioGroup
              name="isLBW"
              required
              value={currentBaby?.isLbw === true ? 'true' : currentBaby?.isLbw === false ? 'false' : null}
            >
              <Row>
                <Col md="6">
                  <Label className="radio-button-label" style={{ minHeight: '40px', height: '40px' }}>
                    <AvRadio
                      name="isLBW"
                      value="true"
                      onChange={handleLBWChange}
                      className="radio-button-input"
                    />
                    Yes
                  </Label>
                </Col>
                <Col md="6">
                  <Label className="radio-button-label" style={{ minHeight: '40px', height: '40px' }}>
                    <AvRadio
                      name="isLBW"
                      value="false"
                      onChange={handleLBWChange}
                      className="radio-button-input"
                    />
                    No
                  </Label>
                </Col>
              </Row>
            </AvRadioGroup>
          </div>

          <div className="mb-4">
            <h6 className="mb-3">Baby&apos;s Sex/Gender</h6>
            <AvRadioGroup
              name="babySex"
              required
              value={currentBaby?.sex || ''}
            >
              <Row>
                <Col md="6">
                  <Label className="radio-button-label" style={{ minHeight: '40px', height: '40px' }}>
                    <AvRadio
                      name="babySex"
                      value="M"
                      onChange={handleSexChange}
                      className="radio-button-input"
                    />
                    Male
                  </Label>
                </Col>
                <Col md="6">
                  <Label className="radio-button-label" style={{ minHeight: '40px', height: '40px' }}>
                    <AvRadio
                      name="babySex"
                      value="F"
                      onChange={handleSexChange}
                      className="radio-button-input"
                    />
                    Female
                  </Label>
                </Col>
              </Row>
            </AvRadioGroup>
          </div>

          <FollowupButtons
            currentStep={8}
            totalSteps={13}
            canGoBack={canGoBack}
            onPrevious={onPrevious}
          />
        </AvForm>
      </div>
    </div>
  );
};

export default BabyAliveStep;
